<template>
  <div v-show="show" class="w3-modal modal-pwa" style="display: block;">
      <div class="w3-modal-content w3-round-large" 
          :style="Object.assign(
            {},
            maxWidth ? { maxWidth: maxWidth } : {},
            minHeight ? { minHeight: minHeight } : {}
          )"
      >
          <div class="w3-container calculation">
              <!-- 關閉按鈕 -->
              <span class="w3-button w3-transparent w3-display-topright close-window-btn" @click="handleClickClose">
                <span class="icon-cross"></span>
              </span>
              <!-- 標題 -->
              <div class="global-title title" v-if="textTitle != ''" v-html="textTitle"></div>
              <!-- 簡述 -->
              <div class="global-descript container" v-if="textDescription != ''" v-html="textDescription"></div>
              <!-- 嵌入內容 -->
              <slot></slot>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  name: "ModalWindow",
  props: {

    //視窗是否呈現
    show: {   
      type: Boolean,
      default: false
    },
    //視窗標題
    textTitle: {   
      type: String,
      default: ""
    },
    //視窗簡述
    textDescription: {   
      type: String,
      default: ""
    },
    // 最大寬度
    maxWidth: {
      type: String
    },
    // 最小高度
    minHeight: {
      type: String
    }
    
  },
  methods: {
    handleClickClose() {
      //alert("子層內建事件");
      this.$emit("ClickClose"); // 再通知父層
    }
  }  
};
</script>
